export default __webpack_public_path__ + "static/media/warning-v2-with-padding.22e3ab20.svg";